<template>
  <b-card :title="$t(chartData.title)">
    <b-row v-if="chartData.type != 'Table'">
      <b-col
        :id="alias"
        lg="6"
        md="6"
        class="chart"
        :style="{ minHeight: height }"
      />
      <b-col lg="6" md="6" class="table">
        <b-table :items="data" :fields="fields" outlined>
          <div v-for="(field, fieldIndex) in fields" :key="fieldIndex">
            <template v-if="$te(field.key + '_color') == true">
              <div class="row">
                <!-- <div class="convention-row" :style="{ backgroundColor: $t(field.key + '_color')}"></div> -->
                <div class="convention-text text-right" style="width: 100%">
                  {{ $t(labels[field.key]) }}
                </div>
              </div>
            </template>
            <template v-else>
              {{ $t(labels[field.key]) }}
            </template>
          </div>

          <template
            v-for="(field, fieldIndex) in removeFields(fields)"
            #[getCell(field.key)]="row"
          >
            <div :key="fieldIndex" class="text-right">
              <template v-if="row.item['type'] == 'currency'">
                {{ row.item[field.key] | currency }}
              </template>
              <template v-else>
                {{
                  row.item[field.key]
                    | currency("", 0, { thousandsSeparator: "," })
                }}
              </template>
              <span
                v-if="row.item[`${field.key}_percentage`]"
                class="text-right"
              >
                ({{
                  (row.item[`${field.key}_percentage`] * 100)
                    | currency("", 2, { thousandsSeparator: "" })
                }}%)</span
              >
            </div>
          </template>

          <template #cell(convention)="row">
            <div
              class="convention"
              :style="{ backgroundColor: $t(row.item.label + '_color') }"
            />
          </template>
          <template #cell(label)="row">
            {{ $t(row.item.label) }}
          </template>
          <template #cell(value)="row">
            <template v-if="row.item.type == 'integer'">
              <div v-if="row.item.value || row.item.value === 0">
                {{
                  row.item.value | currency("", 0, { thousandsSeparator: "," })
                }}
                <!--<span class="text-right">({{row.item.value}})</span>-->
              </div>
              <div v-if="row.item.percentage || row.item.percentage === 0">
                ({{
                  (row.item.percentage * 100)
                    | currency("", 2, { thousandsSeparator: "" })
                }}%)
              </div>
            </template>
            <template v-else-if="row.item.type == 'currency'">
              <div v-if="row.item.value">
                {{ row.item.value | currency }}
              </div>
              <div v-if="row.item.percentage">
                ({{
                  (row.item.percentage * 100)
                    | currency("", 2, { thousandsSeparator: "" })
                }}%)
              </div>
            </template>
            <template v-else>
              {{
                (row.item.percentage * 100)
                  | currency("", 2, { thousandsSeparator: "" })
              }}%
            </template>
          </template>
        </b-table>
        <template #head(convention)="" />
      </b-col>
    </b-row>
    <b-row v-if="chartData.type == 'Table'">
      <b-col>
        <card-employment-policies :data="chartData.data" />
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { ChartBarSimpleHorizontal } from "@/utils/ChartBarSimpleHorizontal";
import { ChartPie } from "@/utils/ChartPie";
import { ChartBarGroupedHorizontal } from "@/utils/ChartBarGroupedHorizontal";
import { ChartBarStackedHorizontal } from "@/utils/ChartBarStackedHorizontal";
import { ChartBarStackedGroupedVertical } from "@/utils/ChartBarStackedGroupedVertical";

export default {
  // Este modulo es el encargado de dibujar las graficas que vienen del endpoint de 'pillar'
  name: "CardChartIndicator",
  props: {
    chartData: {},
    // Resivmos la información a través de props para no tener que manejar nada de vuex por acá
    // y tampoco hacer consultas al endpoint, esto nos permite que las cartas puedan ser usadas
    // en cualquier parte de la aplicación sin depender de nada externo
    alias: {
      default: "",
    },
    height: {
      type: String,
      default: "auto",
    },
  },
  data() {
    return {
      chart: {},
      labels: {},
      fields: [],
      data: [],
    };
  },
  watch: {
    alias: function (newVal, oldVal) {
      var svg = this.$d3.select("#" + oldVal);
      svg.selectAll(".chart").remove();
      setTimeout(() => {
        this.updateData();
      }, 200);
    },
  },
  mounted() {
    this.updateData();
  },
  methods: {
    removeFields() {
      return this.fields.filter(
        (field) => field.key !== "convention" && field.key !== "label"
      );
    },
    getCell(key) {
      return `cell(${key})`; // simple string interpolation
    },
    getHead(key) {
      return `head(${key})`; // simple string interpolation
    },
    updateData() {
      this.updateChart();
      this.updateTable();
    },
    updateChart() {
      // Dependiento el tipo de dato que viene en el endpoint se llama un tipo de grafica diferente
      // En el html hay una propiedad llamada :id="alias" en la cuarta linea
      // Esta es muy importante para que se pueda renderizar todo sin problemas

      switch (this.chartData.type) {
        case "ChartPie":
          this.chart = new ChartPie(this.alias, this.chartData, 80);
          break;
        case "ChartBarSimple":
          this.chart = new ChartBarSimpleHorizontal(this.alias, this.chartData);
          break;
        case "ChartBarGrouped":
          this.chart = new ChartBarGroupedHorizontal(
            this.alias,
            this.chartData
          );
          break;
        case "ChartBarStacked":
          this.chart = new ChartBarStackedHorizontal(
            this.alias,
            this.chartData
          );
          break;
        case "ChartBarStackedGrouped":
          this.chart = new ChartBarStackedGroupedVertical(
            this.alias,
            this.chartData
          );
          break;
        default: // Table
          return; // Hacemos el return para evitar el chart.render()
      }
      this.chart.render();
    },
    updateTable() {
      // Dependiendo el tipo de gráfica hay que organizar la información para poder renderizar la tabla de forma adecuada.
      // En el caso de ChartPie y ChartBarSimple la información pasa directamente
      // Solo se formatea un poco mejor, revisar https://bootstrap-vue.js.org/docs/
      if (
        this.chartData.type === "ChartPie" ||
        this.chartData.type === "ChartBarSimple"
      ) {
        if (this.chartData.type === "ChartBarSimple") {
          this.labels = {
            convention: "",
            label: this.chartData.yAxis,
            value: this.chartData.xAxis,
          };
        } else {
          this.labels = {
            convention: "",
            label: this.chartData.xAxis,
            value: this.chartData.yAxis,
          };
        }

        this.fields = [
          { key: "convention" },
          { key: "label" },
          { key: "value" },
        ];
        this.data = [];
        this.data = this.chartData.data;
      } else if (
        this.chartData.type === "ChartBarGrouped" ||
        this.chartData.type === "ChartBarStacked"
      ) {
        // para los otro tipos de grafica, si hay que reorganizar la información
        const totalGroups =
          typeof this.chartData.data[0].group !== "undefined"
            ? this.chartData.data[0].group.length
            : 0;
        const totalRows = this.chartData.data.length;

        if (totalRows > totalGroups) {
          // Invert rows
          this.labels = {
            label: this.chartData.xAxis,
          };
          this.fields = [{ key: "label" }];

          this.data = [];
          this.chartData.data.map((i) => {
            var columnsData = {
              label: i.label,
            };
            i.group.map((j) => {
              // Add row names
              if (typeof this.labels[j.label] === "undefined") {
                this.fields.push({ key: j.label });
                this.labels[j.label] = j.label;
              }
              // Add value for each column
              columnsData[j.label] = j.value || 0;
              columnsData["type"] = j.type;
              if (j.type !== "percentage" && j.percentage !== undefined) {
                columnsData[`${j.label}_percentage`] = j.percentage;
              }
            });
            this.data.push(columnsData);
          });
        } else {
          this.labels = {
            label: this.chartData.xAxis,
          };

          this.fields = [{ key: "convention" }, { key: "label" }];

          this.data = [];
          const tempObj = {};
          this.chartData.data.map((i) => {
            this.fields.push({ key: i.label });
            this.labels[i.label] = i.label;

            // Extracts from enpoint the groups and re agroup them by group label
            i.group.map((j) => {
              tempObj[j.label] = tempObj[j.label] || {};
              tempObj[j.label][i.label] = tempObj[j.label][i.label] || {};

              tempObj[j.label][i.label]["labelName"] = j.label;
              tempObj[j.label][i.label]["labelValue"] = j.value || 0;
              tempObj[j.label][i.label]["type"] = j.type;
              if (j.type !== "percentage" && j.percentage !== undefined) {
                tempObj[j.label][i.label]["percentage"] = j.percentage;
              }
            });
          });
          Object.keys(tempObj).forEach((i) => {
            const newObj = {};
            Object.keys(tempObj[i]).forEach((j) => {
              newObj["label"] = tempObj[i][j].labelName;
              newObj["type"] = tempObj[i][j].type;
              newObj[`${j}`] = tempObj[i][j].labelValue;
              if (tempObj[i][j].percentage !== undefined) {
                newObj[`${j}_percentage`] = tempObj[i][j].percentage;
              }
            });
            this.data.push(newObj);
          });
        }
      }

      this.fields = Object.keys(this.labels).map((s) => {
        return {
          key: s,
          label: this.$t(this.labels[s]),
        };
      });
      if (this.fields.filter((s) => s.key === "convention").length === 0) {
        this.fields = [{ key: "convention", label: "" }, ...this.fields];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/* components/cards/CardChartIndicator.vue */

@import '../../assets/css/variables.scss';

.card-body {
  flex: none;
  font-family: $font-subtitle;
  height: 100%;
}
.card-title {
  text-align: center;
}
.b-table {
  font-family: $font-text;
  margin-top: 1rem;
  font-size: 0.8rem;
  th {
    text-align: center;
  }
}
.convention,
.convention-row {
  background-color: #000;
  width: 1.5rem;
  height: 1.5rem;
  margin: 0;
}
.convention-row {
  display: inline-block;
}
.convention-text {
  display: inline-block;
  padding-top: 0.2rem;
  padding-left: 1rem;
}
th,
.table-td {
  font-size: 0.8rem;
  text-align: center;
}
</style>
